import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Sheet, SheetContent, SheetTrigger, SheetClose } from './ui/sheet';
import { Menu } from 'lucide-react';
import DigLogo from './DigLogo';
import { NAV } from '../mock';

const Header = () => {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 48);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const SECTOR_ROUTES = ['/information-technology', '/gaming', '/property', '/entertainment'];
  const isActive = (path) =>
    path === '/'
      ? pathname === '/'
      : pathname.startsWith(path) || (path === '/our-investments' && SECTOR_ROUTES.includes(pathname));

  return (
    <header
      className="sticky top-0 z-50 bg-navy"
      style={{
        borderBottom: '1px solid rgba(200,162,76,0.18)',
        boxShadow: scrolled ? '0 6px 24px -12px rgba(0,0,0,0.7)' : 'none',
        transition: 'box-shadow .3s ease',
      }}
    >
      <div className={`dig-container flex items-center justify-between dig-header-bar${scrolled ? ' is-scrolled' : ''}`}>
        <DigLogo variant="header" />

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className="font-label relative"
              style={{
                fontSize: '0.78rem',
                fontWeight: 600,
                letterSpacing: '0.08em',
                color: isActive(item.path) ? 'var(--gold)' : 'rgba(255,255,255,0.86)',
                paddingBottom: 6,
                transition: 'color .25s ease',
              }}
              onMouseEnter={(e) => { if (!isActive(item.path)) e.currentTarget.style.color = 'var(--gold-light)'; }}
              onMouseLeave={(e) => { if (!isActive(item.path)) e.currentTarget.style.color = 'rgba(255,255,255,0.86)'; }}
            >
              {item.label}
              <span
                style={{
                  position: 'absolute', left: 0, bottom: 0, height: 2,
                  width: isActive(item.path) ? '100%' : '0%',
                  background: 'var(--gold)', transition: 'width .3s ease',
                }}
              />
            </Link>
          ))}
        </nav>

        {/* Mobile menu */}
        <div className="lg:hidden">
          <Sheet>
            <SheetTrigger aria-label="Open menu" data-testid="mobile-menu-trigger" className="text-white p-1">
              <Menu size={34} strokeWidth={1.75} style={{ color: 'var(--gold)' }} />
            </SheetTrigger>
            <SheetContent side="right" className="bg-navy border-l-0 w-[80%] max-w-[340px] p-0">
              <div className="px-6 pt-6 pb-8" style={{ borderBottom: '1px solid rgba(200,162,76,0.18)' }}>
                <DigLogo variant="compact" />
              </div>
              <nav className="flex flex-col px-6 py-4">
                {NAV.map((item) => (
                  <SheetClose asChild key={item.path}>
                    <Link
                      to={item.path}
                      className="font-label py-4"
                      style={{
                        fontSize: '0.9rem', fontWeight: 600, letterSpacing: '0.08em',
                        color: isActive(item.path) ? 'var(--gold)' : 'rgba(255,255,255,0.9)',
                        borderBottom: '1px solid rgba(255,255,255,0.08)',
                      }}
                    >
                      {item.label}
                    </Link>
                  </SheetClose>
                ))}
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};

export default Header;
